/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { AnyAction } from 'redux';
import {
    DEFAULT_GUIDE_TASKS,
    DEFAULT_LANDING_LOCATION_URL,
    DEFAULT_LANDING_SCREEN,
} from '../../config';
import { LocationUrls } from '../../core/navigation/LocationUrls';
import { ScreenControllerTypes } from '../../core/navigation/ScreenControllerTypes';
import { ScreenTaskControllerTypes } from '../../core/navigation/ScreenTaskControllerTypes';
import { setLocationUrl } from '../urlchangeevents/urlchangeevents.reducers';
import { setScreenControllerAction, setScreenTaskControllerAction } from './screens.actions';
import { SET_SCREEN_CONTROLLER, SET_SCREEN_TASK_CONTROLLER } from './screens.types';

const initialState: {
    screenController: string;
    screenTaskController: string;
    previousScreenController: string;
    previousScreenTaskController: string;
} = {
    screenController: ScreenControllerTypes.SPLASH_SCREEN,
    screenTaskController: ScreenTaskControllerTypes.NO_TASK,
    previousScreenController: ScreenControllerTypes.SPLASH_SCREEN,
    previousScreenTaskController: ScreenTaskControllerTypes.NO_TASK,
};

const screensReducer = (state = initialState, { type, payload } = <AnyAction>{}) => {
    switch (type) {
        case SET_SCREEN_CONTROLLER:
            return {
                ...state,
                screenController: payload.screenController,
                previousScreenController: payload.previousScreenController,
            };

        case SET_SCREEN_TASK_CONTROLLER:
            return {
                ...state,
                screenTaskController: payload.screenTaskController,
                previousScreenTaskController: payload.previousScreenTaskController,
            };
        default:
            return state;
    }
};

export const setScreenController =
    (screenController: string) => (dispatch: Function, getState: Function) => {
        const { screenController: previousScreenController } = getState().screens;
        dispatch(setScreenControllerAction(screenController, previousScreenController));
    };

export const setScreenTaskController =
    (screenTaskController: string) => (dispatch: Function, getState: Function) => {
        const { screenTaskController: previousScreenTaskController } = getState().screens;
        dispatch(setScreenTaskControllerAction(screenTaskController, previousScreenTaskController));
    };

export const showDefaultScreen = () => (dispatch: Function) => {
    dispatch(setLocationUrl(DEFAULT_LANDING_LOCATION_URL));
    dispatch(setScreenController(DEFAULT_LANDING_SCREEN));
    dispatch(setScreenTaskController(DEFAULT_GUIDE_TASKS));
};

export const showErrorScreen = () => (dispatch: Function) => {
    dispatch(setLocationUrl(LocationUrls.ERROR_SCREEN));
    dispatch(setScreenController(ScreenControllerTypes.ERROR_SCREEN));
    dispatch(setScreenTaskController(ScreenTaskControllerTypes.DEFAULT_ERROR_TASKS));
};

export const showGuideScreen = () => (dispatch: Function) => {
    dispatch(setLocationUrl(LocationUrls.GUIDE));
    dispatch(setScreenController(ScreenControllerTypes.GUIDE));
    dispatch(setScreenTaskController(ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS));
};

export const showLiveTvScreen = () => (dispatch: Function) => {
    dispatch(setLocationUrl(LocationUrls.VIDEO_PLAYER));
    dispatch(setScreenController(ScreenControllerTypes.VIDEO_PLAYER));
    dispatch(setScreenTaskController(ScreenTaskControllerTypes.DEFAULT_VIDEO_PLAYER_TASKS));
};

export const showSettingsScreen = () => (dispatch: Function) => {
    dispatch(setLocationUrl(LocationUrls.SETTINGS_SCREEN));
    dispatch(setScreenController(ScreenControllerTypes.SETTINGS_SCREEN));
    dispatch(setScreenTaskController(ScreenTaskControllerTypes.DEFAULT_SETTING_TASKS));
};

export const showSignInScreen = () => (dispatch: Function) => {
    dispatch(setLocationUrl(LocationUrls.SIGN_IN_SCREEN));
    dispatch(setScreenController(ScreenControllerTypes.SIGN_IN_SCREEN));
    dispatch(setScreenTaskController(ScreenTaskControllerTypes.DEFAULT_SIGN_IN_TASKS));
};

export const showSplashScreen = () => (dispatch: Function) => {
    dispatch(setLocationUrl(LocationUrls.SPLASH_SCREEN));
    dispatch(setScreenController(ScreenControllerTypes.SPLASH_SCREEN));
    dispatch(setScreenTaskController(ScreenTaskControllerTypes.NO_TASK));
};

export default screensReducer;
